import { useState } from "react";
import Details from "./Details";
import Receptionist from "./Receptionist";
import NewDocument from "./NewDocument";

const PropertyDetailsView = () => {
  const [tabs, setTabs] = useState(1);
  return (
    <div>
      <div className="d-flex ac-js gap-4 mt-4">
        <p
          className={`${
            tabs === 1 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer`}
          onClick={() => setTabs(1)}
        >
          {" "}
          Details
        </p>
        <p
          className={`${
            tabs === 2 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
          onClick={() => setTabs(2)}
        >
          Document
        </p>
        <p
          className={`${
            tabs === 3 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
          onClick={() => setTabs(3)}
        >
          Receptionist
        </p>
      </div>
      {tabs === 1 && <Details />}
      {tabs === 2 && <NewDocument setTabs={setTabs} />}
      {tabs === 3 && <Receptionist setTabs={setTabs} />}
    </div>
  );
};

export default PropertyDetailsView;
